export default [
  'addMobile',
  'addWorkPhone',
  'changeCSVFormatting',
  'changeCalendarStartDay',
  'changeCalendarTruncationSettings',
  'changeComissionRate',
  'changeConnectNotificationType',
  'changePassword',
  'changeNavMode',
  'changeThemeMode',
  'checkSendMeText',
  'clickCalendarContact',
  'clickDownloadExcel',
  'clickMicrosoftContact',
  'customizeEmailSignature',
  'defaultAgendaView',
  'defaultDealsView',
  'deletePhoto',
  'disableCoffeeReport',
  'disableCompanyAssignedNotifications',
  'disableConnectEmailNotifications',
  'disableDealAssignedNotifications',
  'disableDealWonNotifications',
  'disableEmailSync',
  'disableEventReminders',
  'disableKeyboardShortcuts',
  'disableMFA',
  'disableMentionsNotifications',
  'disableMergeCompletionNotifications',
  'disableMilestoneNotifications',
  'disablePersonalUseReport',
  'disableRecordCreationNotifications',
  'disableRecordDeletionNotifications',
  'disableRecordRestoreNotifications',
  'disableTaskAssignedNotifications',
  'disableTaskCompleteNotifications',
  'disableTeamUseReport',
  'disableTrackableOpenNotifications',
  'disableTrackableViewNotifications',
  'editDateFormat',
  'editEmailAddress',
  'editFirstName',
  'editLastName',
  'editModeEnabledByDefault',
  'editTimeFormat',
  'editTimeZone',
  'enableCoffeeReport',
  'enableCompanyAssignedNotifications',
  'enableConnectEmailNotifications',
  'enableDealAssignedNotifications',
  'enableDealWonNotifications',
  'enableEventReminders',
  'enableKeyboardShortcuts',
  'enableMFA',
  'enableMentionsNotifications',
  'enableMergeCompletionNotifications',
  'enableMilestoneNotifications',
  'enablePersonalUseReport',
  'enableRecordCreationNotifications',
  'enableRecordDeletionNotifications',
  'enableRecordRestoreNotifications',
  'enableTaskAssignedNotifications',
  'enableTaskCompleteNotifications',
  'enableTeamUseReport',
  'enableTrackableOpenNotifications',
  'enableTrackableViewNotifications',
  'replacePhoto',
  'resetAPIKey',
  'setCurrency',
  'useDefaultEmailClient',
  'usePipelineEmailClient'
]
